import { render, staticRenderFns } from "./ApprovalReminderDialogButton.vue?vue&type=template&id=7c2e0334&scoped=true&"
import script from "./ApprovalReminderDialogButton.vue?vue&type=script&lang=js&"
export * from "./ApprovalReminderDialogButton.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalReminderDialogButton.vue?vue&type=style&index=0&id=7c2e0334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e0334",
  null
  
)

export default component.exports